document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.k8-accordion-row').forEach(block => {

        const accoText = block.querySelector('.k8-accordion-row__bottom');

        block.style.setProperty('--acco-text-height', '0px');

        block.addEventListener('click', () => {
            const isActive = block.classList.toggle('k8-accordion-row--active');

            if (isActive) {
                block.style.setProperty('--acco-text-height', accoText.scrollHeight + 'px');
                accoText.style.paddingTop = '1rem';
                accoText.style.opacity = '1';
            } else {
                block.style.setProperty('--acco-text-height', '0px');
                accoText.style.paddingTop = '0';
                accoText.style.opacity = '0';
            }
        });

    });
});